import * as React from 'react'

import { useWithdrawal } from './hooks'
import { CButton, CCol, CRow } from '@coreui/react-pro'
import { path } from '../../../../libs'

export const WithdrawalDetail = () => {
  const withdrawal = useWithdrawal()

  return (
    <div>
      <CRow>
        <CCol>
          <CButton
            color="primary"
            className="me-2"
            title={'Edit'}
            href={path.billing.withdrawal.edit(withdrawal.transactionId)}
          >
            Edit
          </CButton>
          <div className="mt-2">
            <span className="text-muted">isAuto:</span> {withdrawal.isAuto}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingProvider:</span>{' '}
            {withdrawal.processingProvider}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingMethod:</span>{' '}
            {withdrawal.processingMethod}
          </div>
          <div className="mt-2">
            <span className="text-muted">status:</span> {withdrawal.status}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialAmount:</span>{' '}
            {withdrawal.initialAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialCurrency:</span>{' '}
            {withdrawal.initialCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientAmount:</span>{' '}
            {withdrawal.clientAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCurrency:</span>{' '}
            {withdrawal.clientCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCommission:</span>{' '}
            {withdrawal.clientCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">companyCommission:</span>{' '}
            {withdrawal.companyCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">commissionCurrency:</span>{' '}
            {withdrawal.commissionCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">createdAt:</span>{' '}
            {withdrawal.createdAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">updatedAt:</span>{' '}
            {withdrawal.updatedAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">Client:</span>
            {withdrawal.client.clientId} {withdrawal.client.fullName}
            {withdrawal.client.email} {withdrawal.client.partner}
          </div>
          <div className="mt-2">
            <span className="text-muted">Manager:</span>
            {withdrawal.client.clientId} {withdrawal?.manager?.userId}
          </div>
        </CCol>
      </CRow>
    </div>
  )
}
